import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MAT_DIALOG_DATA, MatDialogClose, MatDialogRef } from '@angular/material/dialog';
import { FolderDocument } from 'src/app/models/server/folder-document';

@Component({
    selector: 'app-delete-document',
    templateUrl: './delete-document.component.html',
    styleUrls: ['./delete-document.component.scss'],
    imports: [MatCardModule, MatButtonModule, MatDialogClose]
})
export class DeleteDocumentComponent {
    /**
     * Constructeur.
     * @param dialogRef
     * @param data
     */
    constructor(
        public dialogRef: MatDialogRef<DeleteDocumentComponent>,
        @Inject(MAT_DIALOG_DATA) public data: FolderDocument
    ) {}
}
